import GroupHomeApp from '@vue/app/GroupHomeApp.vue';
import { createApp } from 'vue';
// 集團入口首頁不打任何 API（品牌清單由伺服器端算好帶進來），
// 故這裡不像 reservation.ts 那樣建立 axios，只掛元件。
await S.import('@main');
await u.domready();
const app = createApp(GroupHomeApp, u.data('groupHome.props'));
app.mount('#group-home-app');
